
import { AdUserDto } from '@/__generated__/globalTypes'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  AssignAssigneeToContactRequestDocument,
  AssignAssigneeToContactRequestMutation,
  AssignAssigneeToContactRequestMutationVariables
} from './gql/__generated__/assignAssigneeToContactRequest.mutation'

@Component
export default class AssignAssigneeDialog extends Vue {
  @Prop() show!: boolean
  @Prop() assignees!: AdUserDto[]
  @Prop() messageId!: string

  assignedAssigneeId = ''
  isLoading = false

  @Watch('show')
  onVisibilityChange() {
    if (!this.show) {
      this.assignedAssigneeId = ''
    }
  }

  async assignAssignee() {
    try {
      this.isLoading = true
      await this.$apolloMutate<AssignAssigneeToContactRequestMutation, AssignAssigneeToContactRequestMutationVariables>(
        {
          mutation: AssignAssigneeToContactRequestDocument,
          variables: {
            assigneeId: this.assignedAssigneeId,
            messageId: this.messageId
          },
          error: 'E4253'
        }
      )
    } finally {
      this.isLoading = false
    }
    this.$emit('assignee-assigned')
  }
}
